<template>
    <google-analytics-inertia/>
    <div class="w-100 h-full">
        <FlashMessages/>
        <HoneybadgerErrorTracking/>
        <frontend-header/>
        <slot></slot>
    </div>
</template>

<script>
import FrontendHeader from "@/Components/FrontendHeader";
import FlashMessages from "@/Components/FlashMessages.vue";
import GoogleAnalyticsInertia from "@/Components/GoogleAnalyticsInertia.vue";
import HoneybadgerErrorTracking from "@/Components/HoneybadgerErrorTracking.vue";

export default {
    name: "Fullscreen",
    components: {HoneybadgerErrorTracking, GoogleAnalyticsInertia, FlashMessages, FrontendHeader},
};
</script>
